import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Styled component for the color grid
export const ColorGrid = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(6, 1fr)',
  gap: '8px',
  marginTop: '8px'
}));

// Styled component for color option
export const ColorOption = styled(Box)(({ color, selected }) => ({
  width: '36px',
  height: '36px',
  borderRadius: '4px',
  backgroundColor: color,
  cursor: 'pointer',
  border: selected ? '3px solid #333' : '1px solid rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
  }
}));